<template>
  <div class="container">
    <el-row :gutter="10">
      <el-card class="box-card" shadow="false">
        <div slot="header" class="clearfix">
          <span>食堂:</span>
          <span>{{batchInfo.eatery_name}}</span>
          <span>餐厅:</span>
          <span>{{batchInfo.canteen.canteen_name}}</span>
        </div>
        <div>
          <el-col :span="12" class="left">
            <el-card class="box-card" shadow="hover">
              <div slot="header" class="clearfix">
                <span>待审查碗碟</span>
                <el-button style="float: right; padding: 3px 10px" type="text" @click="checkFail"
                           class="danger-text">不通过
                </el-button>
                <el-button style="float: right; padding: 3px 0" type="text" class="primary-text"
                           @click="checkPass">审核通过
                </el-button>
              </div>
              <el-col :span="5" v-for="dish in dishList" :key="dish.class_id">
                <el-card class="box-card">
                  <div slot="header" class="clearfix">
                    <span>{{dish.dish_name || "暂无名称"}}</span>
                  </div>
                    <el-popover
                      placement="top-start"
                      width="200"
                      trigger="hover">
                      <img :src="dish.dish_image_url" alt="" width="200px">
                      <div class="image-wrapper" slot="reference">
                        <img :src="dish.dish_image_url" alt="" class="image-item">
                      </div>
                    </el-popover>
                </el-card>
              </el-col>
            </el-card>
          </el-col>
          <el-col :span="12">
            <el-card class="box-card" shadow="hover">
              <div slot="header" class="clearfix">
                <span>餐厅现有碗碟</span>
              </div>
              <el-col :span="5" v-for="dish in modelList" :key="dish.class_id">
                <el-card class="box-card">
                  <div slot="header" class="clearfix">
                    <span>{{dish.dish_name || "暂无名称"}}</span>
                  </div>
                  <div>
                    <el-popover
                      placement="top-start"
                      width="200"
                      trigger="hover">
                      <img :src="dish.dish_image_url" alt="" width="200px" height="200px">
                      <div class="image-wrapper" slot="reference">
                        <img :src="dish.dish_image_url" alt="" class="image-item">
                      </div>
                    </el-popover>
                  </div>
                </el-card>
              </el-col>
            </el-card>
          </el-col>
        </div>
      </el-card>
    </el-row>
  </div>
</template>
<script>
import {mapGetters, mapActions, mapMutations} from 'vuex';
import {apiCheckPassDishes, apiCheckFailDishes, apiQueryCanteenClassList} from '@/api';
import {successMessage, errorMessage} from '@/lib/msg';

export default {
  name: 'dishCheckProcess',
  components: {},
  data () {
    return {
      modelList: []
    };
  },
  mounted () {
    this.getModelList();
  },
  methods: {
    ...mapActions([
      'setUncheckedDishList'
    ]),
    ...mapMutations([
      'emitLoading',
      'removeLoading'
    ]),
    async getModelList () {
      let res = await apiQueryCanteenClassList({canteenId: this.batchInfo.canteen.canteen_id,
        apiKey:
        this.userinfo.api_key});
      this.modelList = res.dish_info_list;
    },
    checkPass () {
      this.$confirm('是否确定审核通过?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(async () => {
        this.emitLoading();
        try {
          await apiCheckPassDishes(this.batchInfo.canteen.canteen_id);
        } catch (e) {
          console.log(e);
          return;
        }
        successMessage('审核完成');
        this.setUncheckedDishList();
        this.$router.push('dishCheck');
        this.removeLoading();
      }).catch(() => {
        errorMessage('您已取消');
      });
    },
    checkFail () {
      this.$prompt('请输入不通过原因', '提示', {
        confirmButtonText: '提交',
        cancelButtonText: '取消',
        inputValidator (value) {
          if (!value) {
            return false;
          } else {
            return true;
          }
        },
        inputErrorMessage: '不通过原因不能为空!'
      }).then(async ({value}) => {
        this.emitLoading();
        try {
          await apiCheckFailDishes({
            canteen_id: this.batchInfo.canteen.canteen_id,
            comment: value
          });
          this.setUncheckedDishList();
          this.$router.push('dishCheck');
          this.removeLoading();
        } catch (e) {
          console.log(e);
        }
      });
    }
  },
  computed: {
    // ...mapGetters([
    //   'modelList'
    // ]),
    userinfo () {
      return this.$store.getters.userinfo();
    },
    batchInfo () {
      return this.$route.query.batchInfo;
    },
    dishList () {
      return this.batchInfo.dish_list;
    }
  }
};
</script>
<style lang="scss" scoped>
  .container {
    .left {
    }
    .box-card {
      .image-wrapper {
        width: 100px;
        height: 100px;
        .image-item {
          width: auto;
          height: auto;
          max-height: 100%;
          max-width: 100%;
        }
      }
    }
    .error-text {
      color: red;
    }
  }

</style>
